import { Text } from "@jobber/components/Text";
import styles from "./Settings.module.scss";

const Settings = () => {
  return (
    <div className={styles.settingsMenu}>
      <Text size={"base"}>
          {localStorage.getItem("account") ?? ""}
      </Text>
    </div>
  );
};

export default Settings;
